import { CNIC, CNICExp, Department, Designation, DOB, Email, Employee, EmpType, JoiningDate, Location, Name, PersonalEmail, Phone, Religion, Reporting, Salary, Status, Team, Tenure } from "../../icons/employee-head/icons";


export const iconRules = [
    { keys: ["employee_id"], Icon: Employee },
    { keys: ["id"], Icon: Employee },
    { keys: ["name"], Icon: Name },
    { keys: ["profile_picture"], Icon: Employee },
    { keys: ["email"], Icon: Email },
    { keys: ["p_phone_number", 'phone'], Icon: Phone },
    { keys: ["department_name", "department", "depart", "dept"], Icon: Department },
    { keys: ["team_name"], Icon: Team },
    { keys: ["designation"], Icon: Designation },
    { keys: ["p_date_of_birth"], Icon: DOB },
    { keys: ["location"], Icon: Location },
    { keys: ["emp_salary"], Icon: Salary },
    { keys: ["p_first_name"], Icon: Name },
    { keys: ["p_last_name"], Icon: Name },
    { keys: ["emp_emptype"], Icon: EmpType },
    { keys: ["emp_jobtype"], Icon: EmpType },
    { keys: ["reporting_authority_name", 'reporting'], Icon: Reporting },
    { keys: ["date_of_joining"], Icon: JoiningDate },
    { keys: ["tenure"], Icon: Tenure },
    { keys: ["tenure_value"], Icon: Tenure },
    { keys: ["p_personal_email"], Icon: PersonalEmail },
    { keys: ["p_residential_address"], Icon: Location },
    { keys: ["p_cnic"], Icon: CNIC },
    { keys: ["p_expiry_date"], Icon: CNICExp },
    { keys: ["p_religion"], Icon: Religion },
    { keys: ["emp_is_active"], Icon: Status },
    { keys: ["relation"], Icon: Religion },
    
];